module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-700.82b5580c33900775f45b.svg";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-700.svg
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-700.svg
// module chunks = styles